export enum ErrorTypeEnum {
  UserExisted = "UserExisted",
  ExistsRoleCode = "ExistsRoleCode",
}
